<template>
    <div>
        <v-dialog persistent v-model="basicSettingsShow" v-if="$auth.user.full_admin" width="700">
            <v-card height="70vh" tile>
                <v-toolbar color="white">
                    <v-toolbar-title class="text-primary">راه‌اندازی سامانه</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="basicSettingsShow = false" icon>
                        <v-icon color="primary" size="23">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="px-4 pt-3">
                    <div class="d-flex align-center">
                        <apexchart
                            :options="chartOptions"
                            :series="[series]"
                            height="150"
                            width="150"
                            type="radialBar"
                        ></apexchart>
                        <p class="mb-0 text-small text-grey-darken-2">عملکرد صحیح این سامانه مستلزم انجام تنظیمات اولیه است.<br>این تنظیمات پایه ترین تنظیمات سامانه برای ارسال تیکت است.</p>
                    </div>
                    <div class="mb-4">
                        <v-list>
                            <v-list-item v-for="item in basicSettings" :value="item.name" class="pa-3" :disabled="selected.includes(item.name)" @click="basicSettingsShow = false; $router.push({ path: item.address })">
                                <template #prepend>
                                    <v-icon :color="selected.includes(item.name) ? 'success' : 'warning'" size="33">{{ selected.includes(item.name) ? 'icon-shield-check' : 'icon-hourglass' }}</v-icon>
                                </template>
                                <v-list-item-title class="font-weight-bold mb-2">{{ item.title }}</v-list-item-title>
                                <v-list-item-subtitle class="text-small">{{ item.subtitle }}</v-list-item-subtitle>
                                <template #append>
                                    <v-btn class="text-small" :color="selected.includes(item.name) ? 'success' : 'secondary'" :variant="selected.includes(item.name) ? 'flat' : 'text'">
                                        <v-icon class="me-2" color="secondary" size="17" v-if="!selected.includes(item.name)">icon-time-fast</v-icon>
                                        {{ selected.includes(item.name) ? 'انجام شد' : `${item.time} دقیقه` }}
                                    </v-btn>
                                </template>
                            </v-list-item>
                        </v-list>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import VueApexCharts from "vue3-apexcharts";
export default {
    components: {
        apexchart: VueApexCharts,
    },
    data() {
        return {
            basicSettingsShow: false,
            series: 0,
            chartOptions: {
                plotOptions: {
                    radialBar: {
                        hollow: {
                            size: "50%",
                        },
                        dataLabels: {
                            name: {
                                show: false,
                            },
                            value: {
                                offsetY: 6,
                                fontFamily: "iransans",
                                fontWeight: 500,
                            },
                        },
                    },
                },
            },
            selected: [],
            basicSettings: [
                {
                    title: 'اطلاعات پروفایل کاربری',
                    subtitle: 'اطلاعاتی از قبیل اسم، موبایل، ایمیل و....',
                    time: '2',
                    name: 'profile',
                    address: '/editProfile',
                },
                {
                    title: 'اطلاعات کلی سامانه',
                    subtitle: 'مواردی مانند عنوان سازمان، لوگو، اطلاعات تماس و ....',
                    time: '3-5',
                    name: 'system',
                    address: '/settings/systemInformation',
                },
                {
                    title: 'مدیریت دپارتمان ها',
                    subtitle: 'برای مدیریت بهتر دپارتمان ها، تنظیمات شعبه و شیفت های کاری را نیز بررسی نمایید',
                    time: '5-10',
                    name: 'department',
                    address: '/departments',
                },
                {
                    title: 'مدیریت محصولات و سرویس ها',
                    subtitle: 'از این ویژگی در عملیات پیشرفته ی در پلن های Corporate و Enterprise استفاده می شود',
                    time: '5-15',
                    name: 'service',
                    address: '/settings/services',
                },
                {
                    title: 'مدیریت دسته بندی موضوعات تیکت',
                    subtitle: 'این ویژگی منجر به دسته بندی موضوعی تیکت ها و دریافت گزارشات آماری خواهد شد',
                    time: '5-15',
                    name: 'category',
                    address: '/settings/ticketCategory',
                },
                {
                    title: 'مدیریت اعضاء سازمان',
                    subtitle: 'مدیران، سرپرستان و سایر همکاران خود را در این بخش تعریف نمایید',
                    time: '10-30',
                    name: 'employee',
                    address: '/employees',
                },
            ],
        };
    },
    methods: {
        async checkBasicSettings(cb) {
            this.selected = [];
            if (!!this.$auth.user.first_name && !!this.$auth.user.last_name && !!this.$auth.user.email && !!this.$auth.user.mobile )
                this.selected.push('profile');
            if (this.$system.departments.length > 2)
                this.selected.push('department');
            if (this.$system.services.length)
                this.selected.push('service');
            if (this.$system.ticketCategories.length)
                this.selected.push('category');
            if (!!this.$system.systemSettings.system_title && this.$system.systemSettings.system_title != 'راهکارهای نرم افزاری هلپیکال')
                this.selected.push('system');
            if(this.$auth.user.to_departments.length > 1)
                this.selected.push('employee');
            if(this.selected.length == 6)
                this.$updateSettings({ system_configed: false, _method: 'put' })
            this.series = Math.round((this.selected.length / 6) * 100);
            cb(this.series)
        },
    },
};
</script>
